export const CONTROL_TOOLTIPS = {
  showRollupHierarchy: 'Group positions for each subaccount within its rollup hierarchy tree',
  showZeroBalances: 'Include historical positions that currently have zero balances',
  includeCash: `Include positions in cash instruments – fiat, and also stablecoins if ‘Treat Stablecoins as Cash’ enabled in Settings`,
} as const;
